import React from "react";
import AppProvider from './AppProvider';
import AppRoute from './AppRoute';

import "./App.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
	return (
		<AppProvider>
            <AppRoute></AppRoute>
        </AppProvider>
	);
}

export default App;